// extracted by mini-css-extract-plugin
export default {"container":"BaseInfo_container__xW5q8","example":"BaseInfo_example__mS6KP","buttonWrapper":"BaseInfo_buttonWrapper__mHDiI"};